"use strict";
// _contact-form.js
// フォーム3ステップ制御
//   - 入力ページ  (#entry)   : sessionStorageに保存 → 確認ページへ遷移
//   - 確認ページ  (#confirm) : sessionStorageから表示 → mail.php（PHP工房）へ POST
//   - 完了ページ  (#complete): sessionStorageをクリア

// sessionStorageキー
var STORAGE_KEY = "contactFormData";

// ===================================
// 入力ページ (#entry)
// ===================================
if (document.querySelector("#entry")) {
  var entryForm = document.querySelector("#contact-form");
  var entryButton = entryForm ? entryForm.querySelector("#button") : null;

  if (entryForm && entryButton) {
    entryButton.addEventListener("click", function (event) {
      if (entryButton.disabled) return;

      var name = document.querySelector("#inName")
        ? document.querySelector("#inName").value.trim()
        : "";
      var email = document.querySelector("#inEmail")
        ? document.querySelector("#inEmail").value.trim()
        : "";
      var inquiry = document.querySelector("#inSelect")
        ? document.querySelector("#inSelect").value
        : "";
      var detail = document.querySelector("#inDetail")
        ? document.querySelector("#inDetail").value.trim()
        : "";

      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ name: name, email: email, inquiry: inquiry, detail: detail })
      );
      event.preventDefault();
      window.location.href = "contact-confirm.html";
    });
  }
}

// ===================================
// 確認ページ (#confirm)
// ===================================
if (document.querySelector("#confirm")) {
  var storedData = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");

  if (!storedData) {
    window.location.href = "contact.html";
  } else {
    function setConfirmValue(selector, value) {
      var el = document.querySelector(selector);
      if (el) el.textContent = value || "";
    }
    setConfirmValue("#confirmName", storedData.name);
    setConfirmValue("#confirmEmail", storedData.email);
    setConfirmValue("#confirmInquiry", storedData.inquiry);
    setConfirmValue("#confirmDetail", storedData.detail);

    var postName = document.getElementById("postName");
    var postEmail = document.getElementById("postEmail");
    var postInquiry = document.getElementById("postInquiry");
    var postDetail = document.getElementById("postDetail");
    if (postName) postName.value = storedData.name || "";
    if (postEmail) postEmail.value = storedData.email || "";
    if (postInquiry) postInquiry.value = storedData.inquiry || "";
    if (postDetail) postDetail.value = storedData.detail || "";

    var mailForm = document.getElementById("phpMailForm");
    var sendButton = document.querySelector("#confirmSendBtn");
    if (mailForm && sendButton) {
      mailForm.addEventListener("submit", function () {
        sendButton.disabled = true;
        sendButton.textContent = "送信中…";
      });
    }
  }
}

// ===================================
// 完了ページ (#complete)
// ===================================
if (document.querySelector("#complete")) {
  sessionStorage.removeItem(STORAGE_KEY);
}
